import {
  AutoSuggestAddressResponseItems,
  FindAddressResponse,
} from '@app/finxone-web-frontend/app/lib/dtos/address.dto';
import {
  ImportUsers,
  KycStatus,
  NotificationAlertTypeEnum,
  NotificationSettings,
  OrganisationVerificationRequest,
  Roles,
  UserInfoType,
  UsersList,
  VerificationOrganisationData,
} from '@finxone-platform/shared/sys-config-types';
import { Observable, Subject, of } from 'rxjs';
import { MockCompaniesHouseService } from './companies-house.service';

export class MockMetadataService {
  // import user observable
  importselecteduser: Subject<ImportUsers> = new Subject();

  mockNotificationSettings: NotificationSettings = {
    [NotificationAlertTypeEnum.DAILY_BALANCE]: {
      sms: false,
      email: false,
      push: true,
      pushNative: true,
    },
    [NotificationAlertTypeEnum.ADD_BENEFICIARY_ALERTS]: {
      sms: true,
      email: false,
      push: false,
      pushNative: true,
    },
    [NotificationAlertTypeEnum.PAYMENTS_REQUEST_ALERTS]: {
      sms: false,
      email: false,
      push: false,
      pushNative: true,
    },
    [NotificationAlertTypeEnum.TRANSACTIONS_SUCCESS_AND_FAILURE_ALERTS]: {
      sms: false,
      email: false,
      push: false,
      pushNative: true,
    },
    conversionSuccessAndFailureAlerts: {
      sms: false,
      email: false,
      push: false,
      pushNative: false,
    },
  };

  getUserProfileDetails(): Observable<UserInfoType> {
    return of({
      fullName: 'Anne Miller',
      firstName: 'Anne',
      middleName: '',
      lastName: 'Miller',
      logo: '',
      email: 'anne@yopmail.com',
      userName: 'Anne',
      dob: '1993-05-01',
      country: 'UK',
      phoneNumber: '+449898989898',
      address1: '145',
      address2: 'Dryclough Rd',
      address3: '',
      address4: '',
      city: 'Huddersfield',
      county: 'West Yorkshire',
      postalCode: 'HD4 5JA',
      flatName: 'Wenlock Terrace',
      propertyName: 'Wenlock Terrace',
      propertyNumber: '82',
      orgList: [
        {
          id: 'b5558138-7f3a-4a29-864d-634987486a77',
          roles: ['manage-users', 'view-organization', 'manage-members'],
          name: 'Google',
          createdDate: '2024-02-04',
        },
        {
          id: 'ac2feff5-9aa1-444f-8147-5e94630ef239',
          roles: ['manage-members', 'view-organization', 'manage-users'],
          name: 'Tesla',
          createdDate: '2024-02-04',
        },
        {
          id: 'ac2feff5-9aa1-444f-8147-5e94630ef237',
          roles: ['manage-members', 'view-organization', 'manage-users'],
          name: 'Organisation Pvt. Ltd.',
          createdDate: '2024-02-04',
        },
        {
          id: 'ac2feff5-9aa1-444f-8147-5e94630ef235',
          roles: ['manage-members', 'view-organization', 'manage-users'],
          name: 'Organisation',
          createdDate: '2024-02-04',
        },
      ],
      organisation: 'b5558138-7f3a-4a29-864d-634987486a77',
      role: 'manage-users',
      settings: JSON.stringify(this.mockNotificationSettings),
      marketingPreferences: { email: false, sms: false, push: false, mail: false },
      applicationReference: '0000000001',
    });
  }

  getUser(): Observable<UserInfoType> {
    return of({
      id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
      organisationId: 'hhh',
      role: 'role-16',
      organisation: 'ac2feff5-9aa1-444f-8147-5e94630ef237',
      fullName: 'John Smith',
      firstName: 'John',
      emailVerified: true,
      country: 'GB',
      phoneVerified: true,
      address1: '5160 Sunnyvale Dr',
      address2: '',
      address3: '',
      address4: '',
      flatName: '',
      propertyName: '',
      propertyNumber: '',
      city: 'Salt Lake City',
      county: 'Utah',
      postalCode: '84120',
      lastName: 'Doe',
      dob: '1995-06-08',
      email: 'kng10@gmail.com',
      middleName: 'n',
      password: 'pass123',
      phoneNumber: '+441234789012',
      projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
      roleId: 'role-16',
      userName: 'kng1233',
      orgList: [
        {
          id: 'b5558138-7f3a-4a29-864d-634987486a77',
          roles: ['manage-users', 'view-organization', 'manage-members'],
          name: 'Google',
          createdDate: '2024-02-04',
        },
        {
          id: 'ac2feff5-9aa1-444f-8147-5e94630ef239',
          roles: ['manage-members', 'view-organization', 'manage-users'],
          name: 'Tesla',
          createdDate: '2024-02-04',
        },
        {
          id: 'ac2feff5-9aa1-444f-8147-5e94630ef237',
          roles: ['manage-members', 'view-organization', 'manage-users'],
          name: 'Organisation Pvt. Ltd.',
          createdDate: '2024-02-04',
        },
        {
          id: 'ac2feff5-9aa1-444f-8147-5e94630ef235',
          roles: ['manage-members', 'view-organization', 'manage-users'],
          name: 'Organisation',
          createdDate: '2024-02-04',
        },
      ],
      extra_attributes: {
        dob: '1995-06-08',
        email: 'kng10@gmail.com',
        firstName: 'Jam',
        lastName: 'sam',
        middleName: 'n',
        password: 'pass123',
        phoneNumber: '+441234789012',
        projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
        roleId: 'role-16',
        userName: 'kng1233',
      },
      settings: JSON.stringify(this.mockNotificationSettings),
      permissions: ['role-17', 'role-18', 'role-19'],
      kycVerificationStatus: KycStatus.SUCCESS,
      activeOrganisationKybStatus: KycStatus.FAILED,
      orgCounter: 1,
      marketingPreferences: { email: false, sms: false, push: false, mail: false },
      profileUpdatePermittedDate: '2025-01-01',
      applicationReference: '0000000001',
    });
  }

  getRoles(): Observable<Roles[]> {
    return of([{ name: 'Role 1', slug: 'role-1' }]);
  }

  getUsers(): Observable<UsersList> {
    return of({
      limit: 2,
      page: 1,
      totalPages: 1,
      totalItems: 1,
      totalRecords: 1,
      result: [
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jhon',
            lastName: 'Doe',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Test',
            lastName: 'test',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: KycStatus.FAILED,
          orgCounter: 1,
        },
        {
          id: 'a93338d0-1b73-4f6d-b1b6-6b6688bce74f',
          organisationId: 'hhh',
          role: 'role-16',
          extra_attributes: {
            dob: '1995-06-08',
            email: 'kng10@gmail.com',
            firstName: 'Jam',
            lastName: 'sam',
            middleName: 'n',
            password: 'pass123',
            phoneNumber: '+441234789012',
            projectId: '5471e302-216e-4ba9-b554-7dd3ee895516',
            roleId: 'role-16',
            userName: 'kng1233',
          },
          kycVerificationStatus: KycStatus.SUCCESS,
          activeOrganisationKybStatus: 'success',
          orgCounter: 1,
        },
      ],
    });
  }

  getImportUsers() {
    return of([
      {
        first_name: 'Annie',
        last_name: 'Miller',
        email: 'annnie.miller@finx1.com',
        phone: null,
        address: null,
      },
      {
        first_name: 'Annie',
        last_name: 'Miller',
        email: 'annnie.miller@finx1.com',
        phone: null,
        address: null,
      },
    ]);
  }

  getOrganisation(orgId: string): Observable<VerificationOrganisationData> {
    return of({
      id: '4eaf57a0-de14-468c-bbf9-1782e3ebe8de',
      name: 'Finxone',
      address: {
        country: 'GB',
        state: 'Utah',
        city: 'Salt Lake',
        street: '5160 Sunnyvale DR',
        address1: '5160 Sunnyvale DR',
        address2: 'Address 2',
        address3: '',
        address4: '',
        postalCode: '123456',
      },
      identificationNumber: '1314422322211',
      incorporationDate: '2025-02-03',
    });
  }
  updateOrganisation(orgId: string, data: any): Observable<OrganisationVerificationRequest> {
    return of({
      name: 'Google',
      country: 'GB',
      address1: '9370 Park Avenue',
      street: 'Near by milestone',
      city: 'Harrow',
      state: 'North Yorkshire',
      postalCode: 'WC14 7NP',
      extraAttributes: {
        'favorite color': 'red',
      },
    });
  }

  generateOtpPhoneEmail(payload: any) {
    return of('1234');
  }

  // The custom-widget bridge's addresses.suggest / addresses.resolve operations
  // go through MetadataService; both share MockCompaniesHouseService's fixture
  // so a suggestion always resolves to a real address.
  autosuggestAddress(address: string): Observable<AutoSuggestAddressResponseItems> {
    return new MockCompaniesHouseService().autosuggestAddress(address);
  }

  getAddressById(id: string): Observable<FindAddressResponse<string[]>> {
    return new MockCompaniesHouseService().getAddressById(id);
  }
}
